// Hiding the outline or :focus ring in an accessible way
// https://jmperezperez.com/outline-focus-ring-a11y/

function doClearNoFocusOutline(evt) {
  if (evt.which === 9) {
    document.documentElement.classList.remove('no-focus-outline');
    document.body.removeEventListener('keyup', doClearNoFocusOutline);
  }
}

document.body.addEventListener('keyup', doClearNoFocusOutline);
